import { fromJS } from 'immutable';

import { createReducer } from 'reducers/utils/helpers';

import { generateTagsColors } from 'utils/TagsHelper';

import { tagsData, addNewTag, removeTag, editTag, assignTag, unassignTag } from './types';

export * from './actions';

const initialState = fromJS({
  availableTags: [],
  network: {
    loading: false,
    error: false,
    success: false,
  },
});

export default createReducer(initialState, {
  [tagsData.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [tagsData.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['availableTags'], generateTagsColors(action.response)),
    ),
  [tagsData.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
  [addNewTag.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [addNewTag.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .mergeIn(['availableTags'], action.response),
    ),
  [addNewTag.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
  [removeTag.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [removeTag.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false),
    ),
  [removeTag.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
  [editTag.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [editTag.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false),
    ),
  [editTag.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
  [assignTag.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [assignTag.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false),
    ),
  [assignTag.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
  [unassignTag.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], false)
        .setIn(['network', 'loading'], true)
        .setIn(['network', 'error'], false),
    ),
  [unassignTag.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false),
    ),
  [unassignTag.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'success'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], true),
    ),
});
